<section class="relative lg:py-24 py-16">
  <div class="container">
      <div class="md:flex justify-center">
          <div class="md:w-3/4">
              <div class="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                <h3 class="text-2xl font-medium mb-4 mt-3">Onze visie</h3>
                <p class="text-black/80"><strong>MUDICO</strong> is een vrije associatie van</p>

                <ul class="list-none text-black/80 mt-3">
                  <li class="flex mt-2"><i class="uil uil-arrow-right text-earth-xdark align-middle ltr:mr-2 rtl:ml-2"></i> <a class='text-earth-dark underline hover:text-earth-xdark' href="/discipline?discid=3">kinderpsychologen</a>,</li>
                    <li class="flex mt-2"><i class="uil uil-asterisk text-earth-xdark align-middle ltr:mr-2 rtl:ml-2 ml-12"></i> gedrags- en gezinstherapeuten,</li>
                    <li class="flex mt-2"><i class="uil uil-asterisk text-earth-xdark align-middle ltr:mr-2 rtl:ml-2 ml-12"></i> orthopedagogen,</li>
                    <li class="flex mt-2"><i class="uil uil-asterisk text-earth-xdark align-middle ltr:mr-2 rtl:ml-2 ml-12"></i> consulent psycholoog,</li>
                    <li class="flex mt-2"><i class="uil uil-asterisk  text-earth-xdark align-middle ltr:mr-2 rtl:ml-2 ml-12"></i> maatschappelijke werker,</li>
                    <li class="flex mt-2"><i class="uil uil-asterisk  text-earth-xdark align-middle ltr:mr-2 rtl:ml-2 ml-12"></i> een auticoach,</li>
                  <li class="flex mt-2"><i class="uil uil-arrow-right text-earth-xdark align-middle ltr:mr-2 rtl:ml-2"></i> <a class='text-earth-dark underline hover:text-earth-xdark' href="/discipline?discid=4">logopedisten</a>,</li>
                  <li class="flex mt-2"><i class="uil uil-arrow-right text-earth-xdark align-middle ltr:mr-2 rtl:ml-2"></i> <a class='text-earth-dark underline hover:text-earth-xdark' href="/discipline?discid=2">een kinderpsychiater</a>,</li>
                  <li class="flex mt-2"><i class="uil uil-arrow-right text-earth-xdark align-middle ltr:mr-2 rtl:ml-2"></i> <a class='text-earth-dark underline hover:text-earth-xdark' href="/discipline?discid=6">een psychomotorische therapeut</a></li>

                </ul>

                <p class="text-black/80 mt-3">... die zich verenigd hebben omdat ze een gelijkaardige visie hebben op de hulpverlening bij
                kinderen van 2,5 tot 18 jaar. Wij geloven dat elk kind ontwikkelingsmogelijkheden heeft en
                stellen met onze behandelingen als doel die ontwikkelingskansen te maximaliseren.  Een vrije
                associatie betekent dat MUDICO een groepspraktijk is waar collega’s op evenwaardige wijze
                op zelfstandige basis met elkaar samenwerken.
                Vanaf juli 2023 bestaat MUDICO uit 4 afzonderlijke vestigingen (groepspraktijken) gelegen te
                As, Diest, Lanaken en Wellen. We zullen spreken van een “praktijknetwerk”.</p>

                <h5 class="text-xl font-medium mb-4 mt-3">Waar staat MUDICO voor?</h5>
                <p class="text-black/80 mt-3">Om te garanderen dat wij optimale zorg op maat kunnen bieden aan onze hulpvragers, vindt
                ons netwerk het van belang om enkele kernwaarden te formuleren.</p>


                <div class="my-12 relative text-earth-xdark text-lg md:text-xl hidden lg:block">
                  <div class="relative md:absolute md:left-4 md:top-8 underline text-center md:text-left m-4 md:m-0 btn hover:bg-earth-try"  (click)="selectTopic('kwaliteit')">Kwaliteitsvol</div>
                  <div class="relative md:absolute md:right-4 md:top-8 underline text-center md:text-left m-4 md:m-0 btn hover:bg-earth-try" (click)="selectTopic('engagement')">Warm engagement</div>

                  <img class='w-1/2 m-auto' src="assets/images/logo_square_bare.png" />

                  <div class="relative md:absolute md:left-4 md:bottom-8 underline text-center md:text-left m-4 md:m-0 btn hover:bg-earth-try" (click)="selectTopic('ontwikkeling')">Samen ontwikkelen</div>
                  <div class="relative md:absolute md:right-4 md:bottom-8 underline text-center md:text-left m-4 md:m-0 btn hover:bg-earth-try" (click)="selectTopic('communicatie')">Open communicatie</div>
                </div>

                <!-- mobile -->
                <div class="container my-12 relative text-earth-xdark text-lg md:text-xl block lg:hidden">
                  <div class="flex justify-center">
                    <img class='w-4/12 object-contain' src="assets/images/logo_square_bare.png" />
                    <div class="w-8/12">
                      <div class="underline text-left my-4 pl-4 btn block" (click)="selectTopic('kwaliteit')">Kwaliteit</div>
                      <div class="underline text-left my-4 pl-4 btn block" (click)="selectTopic('engagement')">Warm engagement</div>
                      <div class="underline text-left my-4 pl-4 btn block" (click)="selectTopic('ontwikkeling')">Samen ontwikkelen</div>
                      <div class="underline text-left my-4 pl-4 btn block" (click)="selectTopic('communicatie')">Open communicatie</div>
                    </div>
                  </div>
                </div>


                <div *ngIf="topic == 'kwaliteit'">
                  <h6 class="text-xl font-medium mb-4 mt-3">Kwaliteit</h6>
                  <p class="text-black/80 mt-3">MUDICO staat voor kwaliteitsvolle hulpverlening en maakt er zijn missie van om elke
                  cliënt en context zo goed en efficiënt mogelijk te begeleiden in hun hulpvraag.
                  MUDICO werkt enkel met <strong>kwalitatief hoogopgeleide medewerkers</strong>, waarmee de
                  wetenschappelijke onderbouwing en het <strong>evidence-based</strong> tewerk gaan van elke
                  discipline zoveel mogelijk gegarandeerd wordt.</p>

                  <p class="text-black/80 mt-3">
                  We verwachten dat elke medewerker een gespecialiseerde <strong>opleiding</strong> heeft gevolgd
                  voor zijn of haar doelgroep. Bovendien zijn alle geassocieerde hulpverleners bij
                  MUDICO erkend door hun respectievelijke beroepsverenigingen. Daarnaast
                  verwachten we dat elke medewerker zijn of haar kennis blijft verfijnen doorheen zijn
                  loopbaan.</p>

                  <p class="text-black/80 mt-3">
                  Binnen het praktijknetwerk proberen we elke discipline van het team tewerk te stellen
                  (met uitzondering van de kinderpsychiater). Dit wil zeggen dat per vestiging een
                  <strong>multidisciplinair team</strong> werkt dat hulpvragen van verschillende lijnen in de zorg kan
                  behandelen (1 e tot en met 3 e lijn). MUDICO engageert zich tot het eerstelijns aanbod
                  door psychologen en orthopedagogen in te zetten in het ELP netwerk, maar voorziet
                  ook therapeuten die in de 2 e en 3 e lijn ervaring hebben. Jonge collega's kunnen
                  ondersteund worden door meer ervaren collega's in de vorm van <strong>supervisie</strong>.</p>

                  <p class="text-black/80 mt-3">
                  Ondanks ons engagement is het tot op heden niet mogelijk om elke discipline per
                  vestiging aan te bieden wegens een schaarste in de zorg. Ga naar de gewenste
                  vestiging om te zien welke disciplines aanwezig zijn. Aangezien we een netwerk zijn
                  en er multidisciplinaire teamoverleggen zijn, is het geen probleem om overkoepelend
                  te werken aan jullie hulpvraag.</p>
                </div>

                <div *ngIf="topic == 'engagement'">
                  <h6 class="text-xl font-medium mb-4 mt-3">Warm engagement</h6>
                  <p class="text-black/80 mt-3">
                  De drijvende kracht van het praktijknetwerk is de betrokkenheid en gedrevenheid van
                  elk teamlid. We zien het dan ook als een meerwaarde dat <strong>warm engagement</strong> wordt
                  opgenomen in de kernwaardes van het gehele team. We geloven dat de basis tot het
                  succes van het praktijknetwerk ligt in de investering in de praktijk én in elkaar.</p>

                  <p class="text-black/80 mt-3">
                  De hulpverleners die werken in het team van MUDICO uiten hun warm engagement
                  naar de <strong>cliënten</strong> door een warme doch professionele werkrelatie, een efficiënt
                  therapieschema dat afgestemd is op de mogelijkheden van zowel cliënt als therapeut
                  en een nauwe opvolging/ overdracht naar collega- hulpverleners. De therapie staat
                  bijgevolg niet op zich maar is ingebed in een warm engagement.</p>
                </div>

                <div *ngIf="topic == 'ontwikkeling'">
                  <h6 class="text-xl font-medium mb-4 mt-3">Een praktijk die zich samen ontwikkelt</h6>
                  <p class="text-black/80 mt-3">MUDICO als concept blijft zich ontwikkelen en een netwerk. Een netwerk aan
                  evenwaardige, kwalitatief hoogstaande, multidisciplinaire groepspraktijken die
                  eenzelfde visie uitdragen. De verschillende vestigingen werken nauw samen en volgens
                  eenzelfde werkwijze, steeds typerend voor en volgens de waarden van MUDICO. Per
                  locatie zijn de vestigingen ingebed in een ruimer netwerk van collega- groepspraktijken

                  en andere voorzieningen (ambulant en residentieel) binnen de zorgsector. Wij zullen
                  dan ook niet aarzelen om cliënten correct door te verwijzen en met zorg over te dragen
                  aan collega's, wanneer wijzelf niet maximaal aan de noden van cliënt en context kunnen
                  voldoen.</p>

                  <p class="text-black/80 mt-3">
                  MUDICO is een netwerkorganisatie dat graag haar kennis en expertise ter beschikking
                  stelt voor iedereen. Daarom zullen wij studiedagen, congressen en lezingen <a class='text-earth-dark underline hover:text-earth-xdark' href='/vormingen'>organiseren</a>.</p>

                  <p class="text-black/80 mt-3">
                  Ook het hulpverleningsaanbod dat MUDICO biedt, blijft uiteraard in ontwikkeling. Alle
                  medewerkers van het team hebben hun eigen aandachtsgebieden en verplichten zichzelf
                  om de nodige evoluties in hun domein op te volgen door zich regelmatig te laten
                  bijscholen en vakliteratuur op te volgen.</p>
                </div>

                <div *ngIf="topic == 'communicatie'">
                  <h6 class="text-xl font-medium mb-4 mt-3">Open communicatie</h6>
                  <p class="text-black/80 mt-3">
                  Communicatie wordt binnen MUDICO aanzien als een belangrijke sleutel om doelen te
                  kunnen verwezenlijken. Het gesprek tussen cliënt en hulpverlener staat hierbij centraal.
                  Communicatie op een open, respectvolle manier over en met cliënten volgens het
                  beroepsgeheim en de GDPR wetgeving spreekt voor zich. MUDICO gaat op een transparante
                  manier op zoek naar antwoorden en een geschikt aanbod per cliënt, waarbij een eerlijke
                  inschatting gemaakt wordt, steunend op wetenschappelijk onderzoek en onze expertise. Wij
                  nemen hierbij de rol in van vertrouwenspersoon waarbij we een veilige gespreksomgeving
                  creëren. Deze open communicatie stelt ons in de mogelijkheid om op zoek te gaan naar
                  gemeenschappelijke belangen, gedeelde inzichten en uiteindelijk concrete handvaten te
                  bieden gericht op de individuele hulpvraag. Dit kan individueel plaatsvinden, maar ook in
                  groep tijdens onze groepstrainingen.</p>

                  <p class="text-black/80 mt-3">
                  Open communicatie binnen het ruimere hulpverlenersnetwerk is eveneens onmisbaar in het
                  kader van warme overdracht, samenwerkingsverbanden of doorverwijzingen.</p>

                  <p class="text-black/80 mt-3">
                  Binnen ons praktijknetwerk wordt belang gehecht aan efficiënt vergaderen. Om de 6 weken
                  komt het multidisciplinair team samen in de verschillende vestigingen om praktijk en
                  discipline-overstijgende casussen te bespreken bij wijze van intervisie. Actief luisteren en
                  feedback kent een belangrijke plaats binnen het team. Binnen de aparte vestigingen zelf
                  kunnen korte overlegmomenten tussen de betrokken collega's plaatsvinden om casussen die
                  meer regio of discipline-gebonden zijn nauw op te volgen.</p>

                  <p class="text-black/80 mt-3">
                  Open communicatie in ons team is eveneens een belangrijke waarde om de visie te
                  kunnen verwezenlijken die we voor ogen hebben. Samenhorigheid, collegialiteit en
                  teamspirit draagt MUDICO hoog in het vaandel.</p>
                </div>



              </div>
          </div><!--end -->
      </div><!--end grid-->
  </div><!--end container-->
</section>
